import { render } from "./DefaultForm.vue?vue&type=template&id=22ac642a&scoped=true"
import script from "./DefaultForm.vue?vue&type=script&lang=js"
export * from "./DefaultForm.vue?vue&type=script&lang=js"

import "./DefaultForm.vue?vue&type=style&index=0&id=22ac642a&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ac642a"]])

export default __exports__